const assistantLogo = 'https://yelda-chat.s3.eu-west-3.amazonaws.com/images/yelda-default-character.png'
import MobileDetect from 'mobile-detect'
import config from '../../config/index'

import { setItem } from '../../lib/localStorage'
import { mergeWithStateWebchatSlots, extractClientPostMessageData } from '../../lib/slot'

const BEFORE_NEW_MESSAGE = 'BEFORE_NEW_MESSAGE'
const AFTER_NEW_MESSAGE = 'AFTER_NEW_MESSAGE'
const SET_HAS_MORE_CONVERSATIONS = 'SET_HAS_MORE_CONVERSATIONS'
const SET_ID_OLDEST_CONVERSATION = 'SET_ID_OLDEST_CONVERSATION'
const SET_PREVIOUS_SCROLL_HEIGHT = 'SET_PREVIOUS_SCROLL_HEIGHT'
const SET_NOT_SEEN_STATUS = 'SET_NOT_SEEN_STATUS'
const SET_NB_NEW_MESSAGE = 'SET_NB_NEW_MESSAGE'
const SET_LOCALE = 'SET_LOCALE'
const SET_TITLE = 'SET_TITLE'
const SHOW_TYPE_INDICATOR = 'SHOW_TYPE_INDICATOR'
const HIDE_TYPE_INDICATOR = 'HIDE_TYPE_INDICATOR'
const SET_CONVERSATION_POPIN_STATUS = 'SET_CONVERSATION_POPIN_STATUS'
const SET_IS_SHOW_LOADER = 'SET_IS_SHOW_LOADER'
const SET_SHOW_CONV_BEGINNING = 'SET_SHOW_CONV_BEGINNING'
const SET_IS_FRESH_CONVERSATION = 'SET_IS_FRESH_CONVERSATION'
const SET_IS_SHOW_LOAD_BTN = 'SET_IS_SHOW_LOAD_BTN'
const SET_INPUT_STATE = 'SET_INPUT_STATE'
const SET_AVATAR = 'SET_AVATAR'
const SET_LIVE_CHAT_AGENT = 'SET_LIVE_CHAT_AGENT'
const SET_STYLE = 'SET_STYLE'
const SET_VOICE_OPTIONS = 'SET_VOICE_OPTIONS'
const SET_UPLOAD_SETTINGS = 'SET_UPLOAD_SETTINGS'
const SET_TTS_STATUS = 'SET_TTS_STATUS'
const SET_START_BTN = 'SET_START_BTN'
const SET_PUSH_NOTIFICATIONS = 'SET_PUSH_NOTIFICATIONS'
const SET_SENDING_STATE = 'SET_SENDING_STATE'
const SET_PARENT_URL = 'SET_PARENT_URL'
const SET_YELDA_PUSH = 'SET_YELDA_PUSH'
const SET_AUDIO_OPTION = 'SET_AUDIO_OPTION'
const SET_WEBKIT_STT_MESSAGE = 'SET_WEBKIT_STT_MESSAGE'
const SET_END_CONVERSATION_ACTIONS = 'SET_END_CONVERSATION_ACTIONS'
const SET_LOCALIZED_ACKNOWLEDGEMENT_TEXTS = 'SET_LOCALIZED_ACKNOWLEDGEMENT_TEXTS'
const SET_DEFAULT_DISPLAY_DELAY_RATING_PANEL = 'SET_DEFAULT_DISPLAY_DELAY_RATING_PANEL'
const SET_ACTIONS_IGNORED_FOR_RATINGS = 'SET_ACTIONS_IGNORED_FOR_RATINGS'
const SET_CONVERSATION_CONTEXT = 'SET_CONVERSATION_CONTEXT'
const SET_RELOAD_BUTTON_STATE = 'SET_RELOAD_BUTTON_STATE'
const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
const SET_NLP_WORD_RULES = 'SET_NLP_WORD_RULES'
const SET_SCROLL_HEIGHT = 'SET_SCROLL_HEIGHT'
const SET_SHORTCUT_MENU = 'SET_SHORTCUT_MENU'
const SET_TIME_ZONE = 'set_time_zone'
const SET_WEBCHAT_SLOTS = 'SET_WEBCHAT_SLOTS'
const SET_EARLY_POST_MESSAGE_EVENTS = 'SET_EARLY_POST_MESSAGE_EVENTS'
const SET_POST_MESSAGE_SLOTS_PROPERTIES = 'SET_POST_MESSAGE_SLOTS_PROPERTIES'
const SET_CONVERSATION_HUB = 'SET_CONVERSATION_HUB'
const SET_CONVERSATIONS = 'SET_CONVERSATIONS'

const md = new MobileDetect(navigator.userAgent)
// Support tablet too
const IS_MOBILE = md.mobile() !== null || md.tablet() !== null

/** Drain the earlyPostMessageEvents list by extracting slots and merging them with existing slots in the state
 * @param {Object} state
 */
function drainPostMessageEventList(state) {
  state.earlyPostMessageEvents.forEach(eventData => {
    const postMessageSlots = extractClientPostMessageData(state.postMessageSlotsProperties, eventData, state.locale)
    // if no postMessageSlots have been extracted, we stop here
    if (!Object.keys(postMessageSlots).length) {
      return
    }
    const updatedSlots = mergeWithStateWebchatSlots(state.webchatSlots || [], postMessageSlots)

    this.dispatch('set_webchat_slots', updatedSlots)
  })
  this.dispatch('set_early_post_message_events', [])
}

const mutations = {
  [SET_SCROLL_HEIGHT](state) {
    state.lastScrollHeight = document.getElementById('chatList').scrollHeight
  },
  [BEFORE_NEW_MESSAGE](state) {
    this.dispatch('set_scroll_height')
    state.isNewMessage = true
  },
  [AFTER_NEW_MESSAGE](state) {
    state.isNewMessage = false
  },
  [SET_TTS_STATUS](state, value) {
    state.isTTSEnabled = value
  },
  [SET_PREVIOUS_SCROLL_HEIGHT](state) {
    state.previousScrollHeight = document.getElementById('chatList').scrollHeight
  },
  [SET_HAS_MORE_CONVERSATIONS](state, value) {
    state.hasMoreConversations = value
  },
  [SET_ID_OLDEST_CONVERSATION](state, value) {
    state.idOldestConversation = value
  },
  [SET_NOT_SEEN_STATUS](state, value) {
    state.notSeenStatus = value
  },
  [SET_NB_NEW_MESSAGE](state, value) {
    state.nbNewMessage = value
  },
  [SET_LOCALE](state, value) {
    setItem('locale', value)
    state.locale = value
  },
  [SET_TITLE](state, value) {
    state.title = value
  },
  [SHOW_TYPE_INDICATOR](state) {
    state.isShownTypeIndicator = true
  },
  [HIDE_TYPE_INDICATOR](state) {
    state.isShownTypeIndicator = false
  },
  [SET_CONVERSATION_POPIN_STATUS](state, value) {
    state.popinStatus = value
  },
  [SET_IS_SHOW_LOADER](state, value) {
    state.isShownLoader = value
  },
  [SET_SHOW_CONV_BEGINNING](state, value) {
    state.isShownConvBeginning = value
  },
  [SET_IS_FRESH_CONVERSATION](state, value) {
    state.isFreshConversation = value
  },
  [SET_IS_SHOW_LOAD_BTN](state, value) {
    state.isShownLoadBtn = value
  },
  [SET_INPUT_STATE](state, value) {
    state.isInputEnabled = value

    // Set or remove placeholder based on input enabled state
    if (value && document.getElementById('input_chat') !== null) {
      this.dispatch('focus_input')
      document.getElementById('input_chat').placeholder = document
        .getElementById('input_chat')
        .getAttribute('data-placeholder')
    } else if (document.getElementById('input_chat') !== null) {
      document.getElementById('input_chat').setAttribute('placeholder', '')
    }
  },
  [SET_SENDING_STATE](state, value) {
    state.isSendingMessage = value

    // If is not mobile enable / disable the input box
    if (!IS_MOBILE) {
      this.dispatch('set_input_state', !value)
    }
  },
  [SET_AVATAR](state, value) {
    state.avatar = value
  },
  [SET_LIVE_CHAT_AGENT](state, value) {
    state.liveChatAgent = value
  },
  [SET_STYLE](state, value) {
    state.style = value
  },
  [SET_VOICE_OPTIONS](state, value) {
    state.isAudioRecordingVisible = value.hasOwnProperty('isAudioRecordingVisible')
      ? value.isAudioRecordingVisible
      : config.IS_AUDIO_RECORDING_VISIBLE
    state.isAudioMobileFront = value.hasOwnProperty('isAudioMobileFront')
      ? value.isAudioMobileFront
      : config.IS_AUDIO_MOBILE_FRONT
    state.isAudioDesktopFront = value.hasOwnProperty('isAudioDesktopFront')
      ? value.isAudioDesktopFront
      : config.IS_AUDIO_DESKTOP_FRONT
  },
  [SET_UPLOAD_SETTINGS](state, value) {
    state.isFileUploadActivated = value.hasOwnProperty('isActivated')
      ? value.isActivated
      : config.IS_FILE_UPLOAD_ACTIVATED
  },
  [SET_START_BTN](state, value) {
    state.isStartBtn = value
  },
  [SET_PUSH_NOTIFICATIONS](state, value) {
    state.pushNotifications = value
  },
  [SET_PARENT_URL](state, value) {
    state.parentUrl = value
  },
  [SET_YELDA_PUSH](state, value) {
    state.yeldaPush = value
  },
  [SET_AUDIO_OPTION](state, value) {
    state.areAudioOptionsVisible = value
  },
  [SET_WEBKIT_STT_MESSAGE](state, value) {
    state.webkitSTTMessage = value
  },
  [SET_END_CONVERSATION_ACTIONS](state, value) {
    state.endConversationActions = value || []
  },
  [SET_LOCALIZED_ACKNOWLEDGEMENT_TEXTS](state, value) {
    state.localizedAcknowledgementTexts = value || {}
  },
  [SET_DEFAULT_DISPLAY_DELAY_RATING_PANEL](state, value) {
    state.defaultDisplayDelayRatingPanel = value
  },
  [SET_ACTIONS_IGNORED_FOR_RATINGS](state, value) {
    state.actionsIgnoredForRatings = value
  },
  [SET_CONVERSATION_CONTEXT](state, value) {
    state.conversationContextList = value
  },
  [SET_RELOAD_BUTTON_STATE](state, value) {
    state.shouldDisplayReloadButton = value
  },
  [SET_ERROR_MESSAGE](state, value) {
    state.errorMessage = value
  },
  [SET_NLP_WORD_RULES](state, value) {
    state.nlpWordRules = value
  },
  [SET_SHORTCUT_MENU](state, value) {
    state.shortcutMenu = value
  },
  [SET_TIME_ZONE](state, value) {
    state.timeZone = value
  },
  [SET_WEBCHAT_SLOTS](state, value) {
    state.webchatSlots = value
  },
  [SET_POST_MESSAGE_SLOTS_PROPERTIES](state, value) {
    state.postMessageSlotsProperties = value

    // If we received postMessageEvents before chat:load, we process them now
    if (state.earlyPostMessageEvents && state.earlyPostMessageEvents.length) {
      drainPostMessageEventList.bind(this, state)()
    }
  },
  [SET_EARLY_POST_MESSAGE_EVENTS](state, value) {
    state.earlyPostMessageEvents = value
  },
  [SET_CONVERSATION_HUB](state, value) {
    state.conversationHub = value
  },
  [SET_CONVERSATIONS](state, value) {
    state.conversations = value
  }
}

const actions = {
  before_new_message({ commit }) {
    commit(BEFORE_NEW_MESSAGE)
  },
  after_new_message({ commit }) {
    commit(AFTER_NEW_MESSAGE)
  },
  set_previous_scroll_height({ commit }) {
    commit(SET_PREVIOUS_SCROLL_HEIGHT)
  },
  scroll_chat_height({ state }) {
    document.getElementById('chatList').scrollTop =
      document.getElementById('chatList').scrollHeight - state.previousScrollHeight
  },
  set_has_more_conversations({ commit }, value) {
    commit(SET_HAS_MORE_CONVERSATIONS, value)
  },
  set_push_notifications({ commit }, value) {
    commit(SET_PUSH_NOTIFICATIONS, value)
  },
  set_id_oldest_conversation({ commit }, value) {
    commit(SET_ID_OLDEST_CONVERSATION, value)
  },
  set_not_seen_status({ commit }, value) {
    commit(SET_NOT_SEEN_STATUS, value)
  },
  set_new_message_count({ commit }, value) {
    commit(SET_NB_NEW_MESSAGE, value)
  },
  set_locale({ commit }, value) {
    commit(SET_LOCALE, value)
  },
  set_title({ commit }, value) {
    commit(SET_TITLE, value)
  },
  show_type_indicator({ commit }) {
    commit(SHOW_TYPE_INDICATOR)
  },
  hide_type_indicator({ commit }) {
    commit(HIDE_TYPE_INDICATOR)
  },
  set_popin_status({ commit }, value) {
    commit(SET_CONVERSATION_POPIN_STATUS, value)
  },
  set_is_show_loader({ commit }, value) {
    commit(SET_IS_SHOW_LOADER, value)
  },
  set_is_show_conv_beginning({ commit }, value) {
    commit(SET_SHOW_CONV_BEGINNING, value)
  },
  set_is_fresh_conversation({ commit }, value) {
    commit(SET_IS_FRESH_CONVERSATION, value)
  },
  set_is_show_load_btn({ commit }, value) {
    commit(SET_IS_SHOW_LOAD_BTN, value)
  },
  set_input_state({ commit }, value) {
    commit(SET_INPUT_STATE, value)
  },
  set_sending_state({ commit }, value) {
    commit(SET_SENDING_STATE, value)
  },
  set_avatar({ commit }, value) {
    commit(SET_AVATAR, value)
  },
  set_live_chat_agent({ commit }, value) {
    commit(SET_LIVE_CHAT_AGENT, value)
  },
  set_style({ commit }, value) {
    commit(SET_STYLE, value)
  },
  set_voice_options({ commit }, value) {
    commit(SET_VOICE_OPTIONS, value)
  },
  set_upload_settings({ commit }, value) {
    commit(SET_UPLOAD_SETTINGS, value)
  },
  // Focusing the input box
  focus_input() {
    // Uses SetTimeout to ensure that everything is loaded
    setTimeout(() => {
      const inputElement = document.getElementById('input_chat')
      if (inputElement) {
        inputElement.focus()
      }
    })
  },
  set_tts_status({ commit }, value) {
    commit(SET_TTS_STATUS, value)
  },
  set_parent_url({ commit }, value) {
    commit(SET_PARENT_URL, value)
  },
  set_yelda_push({ commit }, value) {
    commit(SET_YELDA_PUSH, value)
  },

  set_audio_option({ commit }, value) {
    commit(SET_AUDIO_OPTION, value)
  },

  set_webkit_stt_message({ commit }, value) {
    commit(SET_WEBKIT_STT_MESSAGE, value)
  },
  set_end_conversation_actions({ commit }, value) {
    commit(SET_END_CONVERSATION_ACTIONS, value)
  },
  set_localized_acknowledgement_texts({ commit }, value) {
    commit(SET_LOCALIZED_ACKNOWLEDGEMENT_TEXTS, value)
  },
  set_default_display_delay_rating_panel({ commit }, value) {
    commit(SET_DEFAULT_DISPLAY_DELAY_RATING_PANEL, value)
  },
  set_actions_ignored_for_ratings({ commit }, value) {
    commit(SET_ACTIONS_IGNORED_FOR_RATINGS, value)
  },
  set_conversation_context({ commit }, value) {
    commit(SET_CONVERSATION_CONTEXT, value)
  },
  set_reload_button_state({ commit }, value) {
    commit(SET_RELOAD_BUTTON_STATE, value)
  },
  set_error_message({ commit }, value) {
    commit(SET_ERROR_MESSAGE, value)
  },
  set_nlp_word_rules({ commit }, value) {
    commit(SET_NLP_WORD_RULES, value)
  },
  set_scroll_height({ commit }) {
    commit(SET_SCROLL_HEIGHT)
  },
  set_shortcut_menu({ commit }, value) {
    commit(SET_SHORTCUT_MENU, value)
  },
  set_time_zone({ commit }, value) {
    commit(SET_TIME_ZONE, value)
  },
  set_webchat_slots({ commit }, value) {
    if (value) {
      commit(SET_WEBCHAT_SLOTS, value)
    }
  },
  set_post_message_slots_properties({ commit }, value) {
    commit(SET_POST_MESSAGE_SLOTS_PROPERTIES, value)
  },
  set_early_post_message_events({ commit }, value) {
    commit(SET_EARLY_POST_MESSAGE_EVENTS, value)
  },
  set_conversation_hub({ commit }, value) {
    commit(SET_CONVERSATION_HUB, value)
  },
  set_conversations({ commit }, value) {
    commit(SET_CONVERSATIONS, value)
  }
}

const getters = {
  popinStatus: state => state.popinStatus,
  idOldestConversation: state => state.idOldestConversation,
  hasMoreConversations: state => state.hasMoreConversations,
  pushNotifications: state => state.pushNotifications,
  lastScrollHeight: state => state.lastScrollHeight,
  previousScrollHeight: state => state.previousScrollHeight,
  isNewMessage: state => state.isNewMessage,
  notSeenStatus: state => state.notSeenStatus,
  nbNewMessage: state => state.nbNewMessage,
  locale: state => state.locale,
  isShownTypeIndicator: state => state.isShownTypeIndicator,
  title: state => state.title,
  isShownLoader: state => state.isShownLoader,
  isShownConvBeginning: state => state.isShownConvBeginning,
  isFreshConversation: state => state.isFreshConversation,
  isShownLoadBtn: state => state.isShownLoadBtn,
  isInputEnabled: state => state.isInputEnabled,
  isTTSEnabled: state => state.isTTSEnabled,
  avatar: state => state.avatar,
  style: state => state.style,
  isAudioRecordingVisible: state => state.isAudioRecordingVisible,
  isAudioMobileFront: state => state.isAudioMobileFront,
  isAudioDesktopFront: state => state.isAudioDesktopFront,
  isFileUploadActivated: state => state.isFileUploadActivated,
  isSendingMessage: state => state.isSendingMessage,
  parentUrl: state => state.parentUrl,
  yeldaPush: state => state.yeldaPush,
  areAudioOptionsVisible: state => state.areAudioOptionsVisible,
  webkitSTTMessage: state => state.webkitSTTMessage,
  endConversationActions: state => state.endConversationActions,
  localizedAcknowledgementTexts: state => state.localizedAcknowledgementTexts,
  defaultDisplayDelayRatingPanel: state => state.defaultDisplayDelayRatingPanel,
  actionsIgnoredForRatings: state => state.actionsIgnoredForRatings,
  conversationContextList: state => state.conversationContextList,
  shouldDisplayReloadButton: state => state.shouldDisplayReloadButton,
  errorMessage: state => state.errorMessage,
  nlpWordRules: state => state.nlpWordRules,
  liveChatAgent: state => state.liveChatAgent,
  shortcutMenu: state => state.shortcutMenu,
  timeZone: state => state.timeZone,
  webchatSlots: state => state.webchatSlots,
  postMessageSlotsProperties: state => state.postMessageSlotsProperties,
  earlyPostMessageEvents: state => state.earlyPostMessageEvents,
  conversationHub: state => state.conversationHub,
  conversations: state => state.conversations
}

export default {
  state: {
    is_closed: true,
    title: '',
    popinStatus: config.POPIN_STATUS.CLOSED,
    idOldestConversation: false,
    hasMoreConversations: true,
    pushNotifications: [],
    lastScrollHeight: 0,
    previousScrollHeight: 0,
    isNewMessage: false,
    notSeenStatus: 0,
    nbNewMessage: 0,
    locale: '',
    isShownTypeIndicator: false,
    isShownLoader: false,
    isShownConvBeginning: false,
    isFreshConversation: false,
    isShownLoadBtn: false,
    isInputEnabled: true,
    isTTSEnabled: false,
    avatar: assistantLogo,
    style: {},
    isAudioRecordingVisible: config.IS_AUDIO_RECORDING_VISIBLE,
    isAudioMobileFront: config.IS_AUDIO_MOBILE_FRONT,
    isAudioDesktopFront: config.IS_AUDIO_DESKTOP_FRONT,
    isFileUploadActivated: config.IS_FILE_UPLOAD_ACTIVATED,
    isSendingMessage: false,
    yeldaPush: '',
    parentUrl: '',
    areAudioOptionsVisible: false,
    webkitSTTMessage: '',
    endConversationActions: [],
    localizedAcknowledgementTexts: {},
    defaultDisplayDelayRatingPanel: null,
    actionsIgnoredForRatings: [],
    conversationContextList: [],
    shouldDisplayReloadButton: false,
    errorMessage: null,
    nlpWordRules: null,
    liveChatAgent: null,
    shortcutMenu: [],
    timeZone: 'utc',
    webchatSlots: [],
    postMessageSlotsProperties: null, // null on purpose to differentiate between "not set" and "set but empty"
    earlyPostMessageEvents: [], // Array of postMessage events received before chat:load
    conversationHub: {},
    conversations: []
  },
  getters: getters,
  mutations: mutations,
  actions: actions
}
